import { Link } from "gatsby";
import React from "react";
import WrapRotation from "../primitives/WrapRotation";
import classNames from "classnames";
import Hyphenated from "react-hyphen";

const SpeakerCard = ({
  title,
  imageUrl,
  url,
  position,
  company,
  language,
  name,
  positionImageOnTop = false,
  wordBreak,
}) => {
  // TODO: Random rotation on hover...
  // // Some stuff to randomise the hover states
  // const [hoverRotateDeg1, setHoverRotateDeg1] = useState("");
  // const [hoverRotateDeg2, setHoverRotateDeg2] = useState("");

  // // Initiate these values (after hydration, if I understand correctly)
  // useEffect(() => {
  //   setHoverRotateDeg1(Math.floor(Math.random() * 20) - 10);
  //   setHoverRotateDeg2(Math.floor(Math.random() * 20) - 10);
  // }, []);

  return (
    <>
      <Link
        className={classNames(
          "group block",
          "max-w-full",
          positionImageOnTop
            ? "flex items-start pt-20"
            : "flex items-start pb-20"
        )}
        to={url}
      >
        {/* Wrap around green card and image */}
        <WrapRotation>
          <div
            className={classNames(
              "flex",
              "transition-all duration-200 ease-in-out",
              "group-hover:-translate-x-2",
              "group-hover:scale-105",
              "bg-green",
              positionImageOnTop ? "flex-col-reverse" : "flex-col"
            )}
          >
            <div className="px-4 py-4">
              {/* Name of the speaker */}
              <div
                className="
                  flex
                  items-start
                  justify-between
                "
              >
                {/* Speaker name / talk title */}
                <h3
                  className={classNames(
                    "inline text-lg uppercase"
                    // wordBreak ? "[hyphens:manual] break-all" : ""
                  )}
                >
                  {/* TODO: Temp disabled until font is fixed: */}
                  {wordBreak ? (
                    // <Hyphenated>{title}</Hyphenated>
                    <>{title}</>
                  ) : (
                    <>{title}</>
                  )}
                  {/* {title} */}
                </h3>

                {/* Arrow */}
                <span
                  className="
                    text-lg
                    text-right
                    font-sans-symbols
                  "
                >
                  →
                </span>
              </div>

              <div className="mt-1 flex flex-col flex-wrap">
                {/* Position, Company and Language of the Speaker */}
                <p className="font-bold">
                  <span className="block mb-2">
                    {position && <span className="block mb-0">{position}</span>}
                    {name && <span className="block mb-0">{name}</span>}
                    {company && (
                      <span className="mr-2 leading-1-2">{company}</span>
                    )}
                  </span>
                  {/* Language tag */}
                  {language && (
                    <span className="mt-2 border text-base pt-[0.05em] pr-[0.1em] pl-[0.1em] pb-[0em] !leading-none">
                      {language.replace(/[\])}[{(]/g, "")}
                    </span>
                  )}
                </p>
              </div>
            </div>

            {/* Speaker image */}
            <WrapRotation>
              <div
                className={classNames(
                  "transition-all duration-200 ease-in-out",
                  "group-hover:translate-x-4 ",
                  "group-hover:scale-105",
                  "max-w-full",
                  positionImageOnTop
                    ? "w-full px-8 md:px-6 -mt-20 speaker group-hover:-translate-y-2"
                    : "w-full px-8 lg:px-6 -mb-20 speaker group-hover:translate-y-2"
                )}
              >
                <img
                  className="
                    object-cover
                    w-full
                    aspect-square
                    grayscale
                  "
                  src={imageUrl ? imageUrl : ""}
                  alt={title}
                />
              </div>
            </WrapRotation>
          </div>
        </WrapRotation>
      </Link>
    </>
  );
};

export default SpeakerCard;
